import { logError } from '@savgroup-front-common/configuration/appInsights/AppInsights';

import { MASK_CHAR } from '../../constants';
import { ParsedCountry } from '../../types';
import { removeNonDigits } from '../common';

export const getActiveFormattingMask = ({
  phone,
  country,
  defaultMask = '............',
  disableFormatting = false,
}: {
  phone: string;
  country: ParsedCountry;
  defaultMask?: string;
  disableFormatting?: boolean;
}): string => {
  const format = country.format;

  const handleReturn = (mask: string) => {
    return disableFormatting
      ? mask.replace(new RegExp(`[^${MASK_CHAR}]`, 'g'), '') // remove non MASK_CHAR symbols
      : mask;
  };

  if (!format) {
    return handleReturn(defaultMask);
  }

  if (typeof format === 'string') {
    return handleReturn(format);
  }

  if (!format['default']) {
    logError(
      `[react-international-phone]: default mask for ${country.iso2} is not provided`,
    );

    return handleReturn(defaultMask);
  }

  // format is object value -> parse key regex and get format string
  const matchedFormatKey = Object.keys(format).find((key) => {
    if (key === 'default') {
      return false;
    }

    const isValidRegex =
      key.charAt(0) === '/' && key.charAt(key.length - 1) === '/';

    if (!isValidRegex) {
      logError(
        `[react-international-phone]: format regex "${key}" for ${country.iso2} is not valid`,
      );

      return false;
    }

    const regex = new RegExp(key.substring(1, key.length - 1));
    const valueWithoutDialCode = phone.replace(country.dialCode, '');

    return regex.test(removeNonDigits(valueWithoutDialCode));
  });

  return handleReturn(
    matchedFormatKey ? format[matchedFormatKey] : format['default'],
  );
};
